import { useEffect, useRef } from 'react';

const useTimeouts = () => {
  const timeoutRef = useRef<number[]>([]);

  useEffect(() => {
    const timeouts = timeoutRef.current;
    return () => {
      timeouts.forEach(clearTimeout);
    };
  }, []);

  const timer = (callback: () => void, delay: number) => {
    const timeoutId = setTimeout(callback, delay);
    timeoutRef.current.push(timeoutId);
  };

  return { timer };
};

export default useTimeouts;
